
import { useRef, useState } from 'react';
import { Box, Typography } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const DragDropBox = ({
    onFilesSelected,
    accept = '.pdf,.jpg,.jpeg,.png',
    multiple = true,
    disabled = false,
    helperText = 'PDF, JPG, PNG',
}) => {
    const inputRef = useRef(null);
    const [dragging, setDragging] = useState(false);

    const openBrowse = () => {
        if (!disabled) inputRef.current?.click();
    };

    const handleDrop = (event) => {
        event.preventDefault();
        setDragging(false);

        if (disabled) return;

        const files = Array.from(event.dataTransfer.files || []);
        if (files.length) onFilesSelected?.(files);
    };

    const handleChange = (event) => {
        const files = Array.from(event.target.files || []);

        if (files.length) onFilesSelected?.(files);

        // Allow selecting the same file again.
        event.target.value = '';
    };

    return (
        <Box
            role="button"
            tabIndex={disabled ? -1 : 0}
            aria-disabled={disabled}
            onClick={openBrowse}
            onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    openBrowse();
                }
            }}
            onDragOver={(event) => {
                event.preventDefault();
                if (!disabled) setDragging(true);
            }}
            onDragLeave={() => setDragging(false)}
            onDrop={handleDrop}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 1,
                p: 3,
                border: '2px dashed',
                borderColor: dragging ? 'primary.dark' : 'primary.main',
                borderRadius: 2,
                backgroundColor: dragging ? '#E3F2FD' : '#F7FBFF',
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.6 : 1,
                textAlign: 'center',
            }}
        >
            <CloudUploadIcon color="primary" sx={{ fontSize: 42 }} />

            <Typography variant="subtitle1" fontWeight={600}>
                {dragging
                    ? 'Drop files here'
                    : 'Drag and drop files here'}
            </Typography>

            <Typography variant="body2" color="text.secondary">
                or <Box component="span" sx={{ color: 'primary.main', fontWeight: 600 }}>
                    browse your device
                </Box>
            </Typography>

            <Typography variant="caption" color="text.secondary">
                {helperText}
            </Typography>

            <input
                ref={inputRef}
                type="file"
                hidden
                accept={accept}
                multiple={multiple}
                disabled={disabled}
                onChange={handleChange}
            />
        </Box>
    );
};

export default DragDropBox;
